(function() {
  'use strict';

  // Debug mode - set to false in production
  const DEBUG = true;

  // Track initialized dropdowns to prevent duplicate event listeners
  const initializedDropdowns = new WeakSet();

  function log(message, data) {
    if (DEBUG) {
      console.log('[Info Dropdown]', message, data || '');
    }
  }

  function initInfoDropdowns() {
    // Use section-specific selector to avoid conflicts
    const sections = document.querySelectorAll('.info-drop-down-section');
    
    if (sections.length === 0) {
      log('No sections found');
      return;
    }
    
    sections.forEach(function(section) {
      const dropdowns = section.querySelectorAll('.info-dd-dropdown');
      
      log('Initializing dropdowns in section', { count: dropdowns.length });
      
      dropdowns.forEach(function(dropdown, index) {
        // Skip if already initialized
        if (initializedDropdowns.has(dropdown)) {
          log('Skipping already initialized dropdown', index);
          return;
        }
        
        const header = dropdown.querySelector('.info-dd-dropdown-header');
        
        if (!header) {
          log('No header found for dropdown', index);
          return;
        }
        
        // Mark as initialized
        initializedDropdowns.add(dropdown);
        
        log('Adding click listener to dropdown', index);
        
        header.addEventListener('click', function(e) {
          // Prevent link clicks from toggling
          if (e.target.closest('a')) {
            log('Click on link, preventing toggle');
            return;
          }
          
          const divider = dropdown.querySelector('.info-dd-divider');
          const content = dropdown.querySelector('.info-dd-dropdown-content');
          const wasActive = dropdown.classList.contains('active');
          
          if (wasActive) {
            // Closing: Hide divider immediately for smoothness
            if (divider) {
              divider.style.display = 'none';
            }
            
            // Remove active class to trigger closing animation for content
            dropdown.classList.remove('active');
            
            // Wait for content transition to complete, then set display: none
            const handleTransitionEnd = function(e) {
              // Only handle transitions on content
              if (e.target === content) {
                if (!dropdown.classList.contains('active')) {
                  if (content) content.style.display = 'none';
                }
                if (content) content.removeEventListener('transitionend', handleTransitionEnd);
              }
            };
            
            if (content) {
              content.addEventListener('transitionend', handleTransitionEnd);
            }
            
            // Fallback timeout in case transitionend doesn't fire (400ms + buffer)
            setTimeout(function() {
              if (!dropdown.classList.contains('active')) {
                if (content) {
                  content.style.display = 'none';
                  content.removeEventListener('transitionend', handleTransitionEnd);
                }
              }
            }, 450);
          } else {
            // Opening: Set display first, force reflow, then add active class - all synchronously
            if (divider) {
              divider.style.display = 'block';
            }
            if (content) {
              content.style.display = 'flex';
            }
            
            // Force reflow synchronously to ensure display is applied
            dropdown.offsetHeight;
            
            // Add active class immediately after reflow for single smooth animation
            dropdown.classList.add('active');
          }
          
          const isActive = !wasActive;
          
          log('Dropdown toggled', { 
            index: index, 
            wasActive: wasActive, 
            isActive: isActive,
            dropdown: dropdown
          });
          
          // Update aria attributes for accessibility
          const arrow = dropdown.querySelector('.info-dd-dropdown-arrow');
          if (arrow) {
            arrow.setAttribute('aria-expanded', isActive);
          }
        });
      });
    });
  }

  // Initialize function
  function init() {
    log('Init called', { readyState: document.readyState });
    
    // Wait a bit to ensure DOM is ready, especially with defer
    setTimeout(function() {
      log('Initializing after timeout');
      initInfoDropdowns();
    }, 100);
    
    if (document.readyState === 'loading') {
      log('DOM still loading, waiting for DOMContentLoaded');
      document.addEventListener('DOMContentLoaded', function() {
        log('DOMContentLoaded fired');
        initInfoDropdowns();
      });
    } else {
      log('DOM already ready, initializing immediately');
      initInfoDropdowns();
    }
  }

  // Initialize immediately (works with defer)
  init();
  
  // Also try on window load as a fallback
  window.addEventListener('load', function() {
    log('Window load event fired');
    initInfoDropdowns();
  });

  // Re-initialize when sections are loaded dynamically (Shopify theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    log('Shopify section:load event', event.detail);
    const sectionId = event.detail?.sectionId || event.detail?.section?.id;
    if (sectionId) {
      // Re-initialize all dropdowns in case new ones were added
      initInfoDropdowns();
    }
  });

  // Also listen for section reorder/reload
  document.addEventListener('shopify:section:reorder', function() {
    log('Shopify section:reorder event');
    initInfoDropdowns();
  });
})();

